export var combineMappers = function (mappers) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!mappers || !mappers.length || mappers.some(function (resolver) { return typeof resolver !== 'function'; })) {
        console.warn(mappers + " is expected to be a function array"); // eslint-disable-line no-console
        return {};
    }
    return mappers.reduce(function (map, mapper) { return Object.assign(map, mapper.apply(void 0, args)); }, {});
};
//# sourceMappingURL=combineMappers.js.map